<template>
  <div class="data-table">
    <VTooltip
      :aria-label="translate('aria_label_review_statistics')"
      v-for="(rating, i) in ratings['values']"
      :key="i"
    >
      <template v-slot:activator="{ props }">
        <VListItem density="compact" class="pa-0" v-bind="props">
          <VProgressLinear
            :model-value="rating.percentage"
            :max="maxValue"
            color="winered"
            bg-color="gray"
            height="16"
            role="progressbar"
            aria-valuemin="0"
            :aria-valuemax="maxValue"
            :aria-valuenow="rating.percentage"
            :aria-label="`Progress for ${rating.label}: ${rating.percentage}%`"
          />

          <template v-slot:prepend>
            <span class="rating-label">{{ rating.label }}</span>
          </template>

          <template v-slot:append>
            <div class="rating-values">
              <span class="d-flex justify-end">
                {{
                  unit === 'percentage'
                    ? rating.percentage + ' %'
                    : rating.count
                }}
              </span>
            </div>
          </template>
        </VListItem>
      </template>
      <span>{{
        translate(
          'pdp_customer_review_score_table_x_ratings_title',
          rating.count
        )
      }}</span>
    </VTooltip>
  </div>
</template>

<script>
export default {
  name: 'ReviewStatistics',
  props: {
    ratings: Object,
    unit: {
      type: String,
      default: 'percentage',
      validator(value) {
        return ['percentage', 'count'].includes(value)
      }
    },
    maxValue: {
      type: [Number, String],
      default: 100
    }
  }
}
</script>

<style scoped>
.data-table {
  min-width: 250px;
}
.rating-values {
  width: 50px;
}
.rating-label {
  width: 80px;
}
</style>
